import { render, staticRenderFns } from "./TypeMoldDialog.vue?vue&type=template&id=16ca11c7&"
import script from "./TypeMoldDialog.vue?vue&type=script&lang=js&"
export * from "./TypeMoldDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports